// extracted by mini-css-extract-plugin
export default {"preloader":"preloader-d3OQ","bg":"bg-aGxM","main":"main-fJAi","rotate":"rotate-r31y"};